import {
    PayerReactivationIconLayout
} from "Layouts/PayerReactivationPopup/PayerReactivationIconLayout";
import Game from '../../../Game';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import DateHelper from '../../../Utility/DateHelper';
import TextComponent from '../../../Component/Render/Text';
import PayerReactivationHandler from '../../../System/UI/Menu/PayerReactivationHandler';
import Renderable from '../../../Component/Renderable';
import { GameObjectEvent } from '../../../GameObject/GameObject';
import CleanupManager from '../../../Utility/CleanupManager';
import Element from '../../../Prototype/UI/Element';
import TransformComponent from '../../../Component/Transform';
import { TickerEvent } from '../../../Utility/Ticker';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import Interactable from '../../../Component/Interactable';
import { IGameState } from '../../../State/Game/IGameState';
import StateComponent from '../../../Component/State';
import { IAPStateHelper } from 'State/Player/IAP/IAPStateHelper';
import { Layout } from '../../../Utility/layout/createLayout';
import { ProductId } from 'Utility/Product';

export default class PayerReactivationOfferIcon extends Element {
    private layout: any;
    private cleanupManager: CleanupManager;

    private offerKey: ProductId;

    public create(props: { x: number; y: number }): void {
        super.create({});

        this.cleanupManager = new CleanupManager();
        this.layout = new PayerReactivationIconLayout();
        this.layout.root.getComponent(TransformComponent).position.set(props.x, props.y);
        this.addChild(this.layout.root);

        this.offerKey = IAPStateHelper.getAvailablePayerReactivationOfferKey(Game.store.getState()) as ProductId;

        this.layout.root.getComponent(Interactable).toggleable = true;
        this.layout.root.getComponent(Interactable).tintOnDisable = true;
        applyDefaultButtonAnimation(this.layout.root);

        this.layout.root.on(GameObjectEvent.SELECTED, this.handleClick);
        Game.ticker.on(TickerEvent.SECONDS_INTERVAL, this.handleTick);

        this.cleanupManager.add(() => {
            this.layout.root.off(GameObjectEvent.SELECTED, this.handleClick);
            Game.ticker.off(TickerEvent.SECONDS_INTERVAL, this.handleTick);
        });

        this.addComponent(StateComponent, {
            handleStateChanged: this.handleStateChanged,
        });
    }

    private readonly handleStateChanged = (state: IGameState): void => {
        if (this.offerKey === undefined) return;

        if (
            !IAPStateHelper.isPayerReactivationOfferAvailable(state)
        ) {
            this.removeComponent(StateComponent);
            this.cleanupManager.cleanUpAll();
            this.getComponent(Renderable).visible = false;
        }
    };

    private readonly handleClick = (): void => {
        PlayerActions.showPayerReactivationPopup();
    };

    private readonly handleTick = (): void => {
        const shownAt = IAPStateHelper.getPayerReactivationOfferStart(Game.store.getState());
        const timeLeft = Math.max(0, shownAt + PayerReactivationHandler.OFFER_TIME - DateHelper.now.getTime());

        if (timeLeft === 0) {
            this.getComponent(Renderable).visible = false;
            return;
        }

        this.layout.timeText.getComponent(TextComponent).text = DateHelper.format(timeLeft, 'hh:mm:ss');
    };

    public destroy(): void {
        this.cleanupManager.cleanUpAll();
        super.destroy();
    }
}
